import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { API_BASE_URL } from '../config';

const OAuthCallback = () => {
  const { login } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const processedRef = useRef(false); // flag to ensure one-time processing

  useEffect(() => {
    if (processedRef.current) return;

    const params = new URLSearchParams(location.search);
    const code = params.get('code');

    if (code) {
      processedRef.current = true;

      fetch(`${API_BASE_URL}/api/google-callback?code=${code}`)
        .then(response => {
          console.log('Fetch response status:', response.status);
          return response.json();
        })
        .then(data => {
          console.log('OAuth callback response data:', data);

          if (data.success && data.user) {
            // ✅ Normalize backend keys for frontend compatibility
            const normalizedUser = {
              ...data.user,
              email: data.user.email_id, // ✅ map email_id → email
            };

            login(normalizedUser);
            localStorage.setItem("user", JSON.stringify(normalizedUser));
            localStorage.setItem("referralCode", normalizedUser.my_referral_code || "N/A");

            // Clear query params from URL
            window.history.replaceState(null, '', window.location.pathname);

            // Navigate to chat
            navigate('/', { replace: true });
          } else {
            console.error('No user data received or login failed:', data);
            navigate('/login');
          }
        })
        .catch(err => {
          console.error('Error during Google callback:', err);
          navigate('/login');
        });
    } else {
      navigate('/login');
    }
  }, [location, login, navigate]);

  return (
    <div>
      <p>Processing authentication... Please wait.</p>
    </div>
  );
};

export default OAuthCallback;
